<template>
    <x-modal :id="id" :title="title">
        <form :action="action" 
            :id="formId"
            method="POST" 
            enctype="multipart/form-data"
            class="clearfix">
            <input type="hidden" name="_token" :value="csrf"/>
            <x-form-group label="Pilih File"
                :is-required="true">
                <input :name="fileInputName" 
                    type="file" 
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                    class="form-control" />
                <div class="help-block">
                    Jenis File: *.xls, *.xlsx.
                    <span v-if="templateUrl">
                        <br /><a :href="templateUrl" target="_blank">Download</a> template import.
                    </span>
                </div>
            </x-form-group>
            <slot></slot>
        </form>
        <template #footer>
            <x-close-modal-button />
            <button type="submit"
                class="btn btn-success"
                :form="formId">{{ submitLabel }}</button>
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from './XCloseModalButton.vue'
import XFormGroup from './XFormGroup.vue'
import XModal from './XModal.vue'
export default {
    components: { XCloseModalButton, XModal, XFormGroup },
    data() {
        return {
            csrf: null,
        }
    },
    mounted() {
        this.csrf = $('meta[name="csrf-token"]').attr('content')
    },
    props: {
        action: {
            type: String,
            required: true,
            default: null,
        },
        formId: {
            type: String,
            required: false,
            default: 'import-excel-form',
        },
        fileInputName: {
            type: String,
            required: false,
            default: 'file',
        },
        id: {
            type: String,
            required: false,
            default: 'import-excel-modal',
        },
        submitLabel: {
            type: String,
            required: false,
            default: 'Import',
        },
        templateUrl: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: false,
            default: 'Import Excel',
        },
    },
}
</script>